import { Component, inject } from '@angular/core';
import { IxMenuAboutItem, IxIcon } from '@siemens/ix-angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { AppVersion } from '../../../environments/app.version';

@Component({
  selector: 'about-info',
  imports: [IxMenuAboutItem, IxIcon, TranslateModule],
  styleUrl: './about-info.component.scss',
  template: `
    <ix-menu-about-item [label]="'NAVIGATION.INFO' | translate">
      <b>{{applicationName()}}</b>
      <p><i>{{versionString}}</i></p>
      <p>Copyright © 2025 Siemens Mobility GmbH</p>

      <a [href]="'ABOUT_AND_LEGAL.CORPORATE_INFORMATION_URL' | translate" target="_blank" class="external-link-group">
        <ix-icon name="chevron-right-small"></ix-icon> {{'NAVIGATION.CORPORATE_INFORMATION' | translate}}
      </a>

      <a [href]="'ABOUT_AND_LEGAL.DATA_PRIVACY_URL' | translate" target="_blank" class="external-link-group">
        <ix-icon name="chevron-right-small"></ix-icon> {{'NAVIGATION.PRIVACY_POLICY' | translate}}
      </a>

      <a [href]="'ABOUT_AND_LEGAL.TERMS_OF_USE_URL' | translate" target="_blank" class="external-link-group">
        <ix-icon name="chevron-right-small"></ix-icon> {{'NAVIGATION.TERMS_OF_USE' | translate}}
      </a>
    </ix-menu-about-item>
  `
})
export class AboutInfoComponent {
  private translateService = inject(TranslateService);

  applicationName = toSignal(this.translateService.get('APP.NAME').pipe(
    map(appName => AppVersion.flavor === "PRD" ? appName : `${appName} (${AppVersion.flavor})`)
  ), { initialValue: "APP.NAME" });

  versionString = `Version: ${AppVersion.appVersion}-${AppVersion.gitHash} (${AppVersion.flavor}) from ${new Date(AppVersion.buildTimestamp).toLocaleString()}`;
}
